import { render } from "./BoqList.vue?vue&type=template&id=5516c97c&scoped=true"
import script from "@/assets/boq/BoqList.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqList.js?vue&type=script&lang=js"

import "./BoqList.vue?vue&type=style&index=0&id=5516c97c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516c97c"]])

export default __exports__